/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import catala from './catala';
import english from './english';
import français from './français';

const messages = {
    Castellano: castellano,
    Català: catala,
    English: english,
    Français: français,
}

export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js